import React, { useState } from "react";

import { Mode } from "../../../utils/utility";
import { TextField, TextFieldProps } from "./TextField";

export const PhoneField = (props: TextFieldProps) => {
  // Props
  let { value } = props;

  // State
  const [clicked, setClicked] = useState(false);

  // Actions
  if (value === "" && clicked) {
    value = "+49";
  }

  return (
    <TextField
      {...props}
      type="tel"
      InputProps={{ onClick: () => setClicked(true) }}
    />
  );
};

PhoneField.defaultProps = {
  mode: Mode.Edit,
  variant: "outlined",
}
